import { render, staticRenderFns } from "./BranchRetrieveUpdate.vue?vue&type=template&id=37117c0a"
import script from "./BranchRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./BranchRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports